import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { AlienLogo } from "@/components/AlienLogo";

const links = [
  { to: "/#band", label: "Band" },
  { to: "/#singolo", label: "I Nostri Pezzi" },
  { to: "/#live", label: "Live" },
  { to: "/#merch", label: "Merch" },
  { to: "/#gallery", label: "Foto Live" },
  { to: "/live", label: "Calendario" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const goHome = (e) => {
    e.preventDefault();
    setOpen(false);
    if (location.pathname === "/") {
      // Already on home — just scroll to top smoothly
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      // Navigate to home, then scroll top after route change
      navigate("/");
      setTimeout(() => window.scrollTo({ top: 0, behavior: "auto" }), 0);
    }
  };

  const handleAnchor = (e, to) => {
    // Anchor links like /#band
    if (!to.startsWith("/#")) return; // let default work for /live
    e.preventDefault();
    setOpen(false);
    const hash = to.slice(1); // "#band"
    if (location.pathname === "/") {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      // Keep URL in sync so the anchor is shareable/deep-linkable
      window.history.replaceState(null, "", to);
    } else {
      navigate("/" + hash);
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
    }
  };

  return (
    <header
      className="fixed top-0 left-0 right-0 z-40 bg-black/80 backdrop-blur-md border-b border-white/10"
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-5 py-3 md:px-10 md:py-4">
        <a href="/" onClick={goHome} className="flex items-center gap-3 group cursor-pointer" data-testid="nav-home-link">
          <AlienLogo size={34} />
          <span className="font-display text-xl md:text-2xl tracking-widest text-white group-hover:text-[color:var(--alien)] transition-colors">
            TOO MUCH HOME
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.to}
              href={l.to}
              onClick={(e) => handleAnchor(e, l.to)}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="uppercase text-sm tracking-widest text-white/70 hover:text-[color:var(--alien)] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <button
          className="md:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-black/95" data-testid="nav-mobile-panel">
          <div className="flex flex-col px-5 py-4 gap-4">
            {links.map((l) => (
              <a
                key={l.to}
                href={l.to}
                onClick={(e) => handleAnchor(e, l.to)}
                data-testid={`nav-mobile-${l.label.toLowerCase()}`}
                className="uppercase text-base tracking-widest text-white/80 hover:text-[color:var(--alien)]"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};
